window.customElements.define(
  'availability-badge',
  class extends window.HTMLElement {
    connectedCallback() {
      this.initDOMELements();
      this.initEventListeners();
    }

    initDOMELements() {
      this.badges = this.querySelectorAll('#badge');
    }

    initEventListeners() {
      window.addEventListener('variant:change', (event) => {
        this.updateBadges(event.detail.variant);
      });
    }

    updateBadges(variant) {
      this.activeBadge = Array.from(this.badges).find((badge) => badge.dataset.variantId === variant.id.toString());

      this.badges.forEach((badge) => {
        badge.classList.add('hidden');
      });

      this.activeBadge.classList.remove('hidden');

      this.toggleDynamicUsp(this.activeBadge);
    }

    toggleDynamicUsp(activeBadge) {
      if (activeBadge.hasAttribute('data-hide-if-preorder')) {
        document?.querySelector('.dynamic-usp[data-hide-if-preorder]')?.classList?.add('hidden');
      } else {
        document?.querySelector('.dynamic-usp[data-hide-if-preorder]')?.classList?.remove('hidden');
      }
    }
  }
);
